module.exports = __webpack_public_path__ + "static/media/client.6252343f.png";